import { FC } from 'react'

type ProductUnitCategoryTagProperties = {
  categories: string[]
  selectedCategory: string
  onCategorySelect: (category: string) => void
}

export const ProductUnitCategoryTag: FC<ProductUnitCategoryTagProperties> = ({
  categories,
  selectedCategory,
  onCategorySelect,
}) => {
  return (
    <div className="cmp-product-units__category-tags">
      {categories.map((category) => {
        const isActive = selectedCategory.toLowerCase() === category.toLowerCase()
        return (
          <button
            key={category}
            className={`cmp-product-units__category-tag ${
              isActive ? 'cmp-product-units__category-tag--is-active' : ''
            }`}
            onClick={() => onCategorySelect(isActive ? '' : category)}
            onKeyDown={(event_) => {
              if (event_.key === 'Enter' || event_.key === ' ') {
                event_.preventDefault()
                onCategorySelect(isActive ? '' : category)
              }
            }}
            tabIndex={0}
            aria-pressed={isActive}
          >
            {category}
          </button>
        )
      })}
    </div>
  )
}
